<template>
  <el-card>
    <div class="main">
      <el-form inline class="global-form">
        <el-form-item prop="materialName">
          <el-input v-model="searchForm.materialName" clearable placeholder="请输入物料关键字"></el-input>
        </el-form-item>
        <el-form-item prop="materialTypeId">
          <el-cascader placeholder="请选择物料分类" ref="cascader" clearable v-model="searchForm.materialTypeId"
            @change="closeCascader" :props="{ ...props, checkStrictly: true, emitPath: false }"
            :options="materialTypeData"></el-cascader>
        </el-form-item>
        <el-form-item prop="isStop">
          <el-select v-model="searchForm.isStop" clearable placeholder="请选择状态">
            <el-option label="启用" value="0"></el-option>
            <el-option label="禁用" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>

      <el-button class="mb10" @click="$router.push('/property/materialinfo/add')" type="primary" v-show="$ButtonShow('YMA_ADD_01')">新增物料</el-button>
      <el-button class="mb10" type="primary" @click="importVisible = true" v-show="$ButtonShow('YMA_ADD_01')">批量导入物料</el-button>

      <el-table v-loading="loading" :data="tableData" class="global-table">
        <el-table-column label="物料名称" show-overflow-tooltip prop="materialName"></el-table-column>
        <el-table-column label="物料编码" show-overflow-tooltip prop="materialCode"></el-table-column>
        <el-table-column label="物料分类" show-overflow-tooltip prop="materialTypeName"></el-table-column>
        <el-table-column label="品牌名称" show-overflow-tooltip prop="brand"></el-table-column>
        <el-table-column label="单位" show-overflow-tooltip prop="company"></el-table-column>
        <el-table-column label="规格" show-overflow-tooltip prop="specifications"></el-table-column>
        <el-table-column label="供应商名称" show-overflow-tooltip prop="supplierName"></el-table-column>
        <el-table-column label="状态" show-overflow-tooltip prop="isStop">
          <template v-slot="{ row }">
            <el-switch v-model="row.isStop" :active-value="0" :inactive-value="1"
              @change="() => changeState(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="120px" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text"
              @click="$router.push('/property/materialinfo/detail?materialId=' + row.materialId)">查看</el-button>
            <el-button type="text"
              @click="$router.push('/property/materialinfo/edit?materialId=' + row.materialId)" v-show="$ButtonShow('YMA_EDT_01')">编辑</el-button>
            <el-button type="text" @click="deleteRow(row.materialId)" v-show="$ButtonShow('YMA_DEL_01')">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <global-pagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
        :page-size.sync="size" :total="total">
      </global-pagination>

      <ImportData :isShowImport.sync="importVisible" templateKey="materialImportTemplate" @onSuccess="onSearch">
      </ImportData>
    </div>
  </el-card>
</template>

<script>
import ImportData from './ImportData.vue'

export default {
  components: {
    ImportData
  },
  data() {
    return {
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      tableData: [],

      importVisible: false,

      searchForm: {
        materialName: '', // 物料名称
        materialTypeId: '', // 物料分类
        isStop: null // 状态0启用1禁用
      },

      warehouseData: [],
      materialTypeData: [],
      materialTypeForm: {
        materialTypeId: '',
        materialTypeName: '',
        parentMaterialTypeId: ''
      },

      props: {
        value: 'materialTypeId',
        label: 'materialTypeName',
        children: 'childNode'
      }
    }
  },
  computed: {
    projectList() {
      return this.$store.isStop.projectList
    }
  },
  created() {
    this.loadData()
    this.loadMaterialType()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.material.selectYhMaterialInfoByPage, {
        page: this.page,
        size: this.size,
        ...this.searchForm
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    importSuccess() {
      this.importVisible = false
      this.loadData()
    },
    closeCascader() {
      this.$refs.cascader.dropDownVisible = false
    },
    changeState(data) {
      this.$axios.post(this.$apis.material.stopYhMaterial, data)
    },
    loadMaterialType() {
      this.$axios.get(this.$apis.material.selectYhMaterialTypeByList).then(res => {
        this.materialTypeData = res || []
      })
      // this.$axios.get(this.$apis.material.selectYhMaterialTypeByList,{
      //   isDel: 1
      // }).then(res => {
      //   this.materialTypeData = res
      // })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    deleteRow(materialId) {
      this.$confirm('确认删除该物料嘛？', '提示').then(() => {
        this.$axios.post(this.$apis.material.deleteYhMaterial, {
          materialId
        }).then(() => {
          this.$message.success('删除成功!')
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/color.scss';

.main {
    width: 100%;
    padding: 0px 10px;
}

.dialog-form {
  ::v-deep .el-dialog__body {
    padding: 20px 20px 20px 20px;

    .el-form-item--small.el-form-item {
      margin-bottom: 30px;
    }
  }

  ::v-deep .el-dialog__header {
    border-bottom: 1px solid #dddddd;
    height: 51px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px 0 20px;

    .el-dialog__title {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
  }
}

.custom-tree {
  ::v-deep .el-tree-node__content {
    height: 32px;
  }

  ::v-deep .el-tree-node__content:hover {
    background-color: #E8FAF7 !important;
    color: $color-default;

    .icon {
      display: inline-block;
    }
  }

  .nodeName {
    font-size: 14px;
  }

  .icon {
    position: absolute;
    right: 0;
    display: none;

    i {
      margin-right: 10px;
    }

    .el-icon-delete {
      color: red;
    }
  }
}
</style>